import React from 'react';
import { Col, Form, Row, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const InfoSection = ({ shoppingCenters }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Informazioni Generali')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Outlet Village')} name='shopping_center_id'>
          <Select placeholder={t('Selezioni opzione')}>
            <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
            {shoppingCenters.map((item) => (
              <Select.Option key={item.id} value={item.id}>
                {item.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(InfoSection);
